import { render, staticRenderFns } from "./CardInfoQuantity.vue?vue&type=template&id=b64cdde4&scoped=true&"
import script from "./CardInfoQuantity.vue?vue&type=script&lang=js&"
export * from "./CardInfoQuantity.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoQuantity.vue?vue&type=style&index=0&id=b64cdde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64cdde4",
  null
  
)

export default component.exports